/**
 * Plate and phone of the driver as the manager sees them.
 *
 * Once a driver has accepted, their profile is the source of truth. When the profile has none, the
 * manager's own entry from the order is shown instead of nothing — marked «по заявке», because
 * under an open link the person who accepted may not be the one typed into the order. Before anyone
 * accepts, the order's value is simply the plan and needs no mark.
 *
 * Same rule and wording in the app (mobile/src/domain/shipment.ts).
 */
export const FROM_ORDER_MARK = 'по заявке'

export function withFromOrderMark(value: string): string {
  return `${value} (${FROM_ORDER_MARK})`
}

export function pickWithOrderFallback(
  accepted: boolean,
  fromProfile: string | null | undefined,
  fromOrder: string | null | undefined,
): string {
  const real = accepted ? fromProfile?.trim() : ''
  if (real) return real
  const planned = fromOrder?.trim()
  if (!planned) return ''
  return accepted ? withFromOrderMark(planned) : planned
}

/**
 * The driver name typed into the order, when someone else accepted it — shown as «В заявке был
 * указан», so the manager notices the open link was taken by a different person. Empty otherwise.
 *
 * Same rule in the app (mobile/src/screens/order-details/OrderDetailsScreen.tsx).
 */
export function plannedDriverIfDifferent(
  accepted: boolean,
  acceptedName: string | null | undefined,
  plannedName: string | null | undefined,
): string {
  const real = acceptedName?.trim()
  const planned = plannedName?.trim()
  if (!accepted || !real || !planned || real === planned) return ''
  return planned
}
